import React from 'react';
import propTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const SocialMetaTags = ({title, description, image_url, external_url}) => {
    return (
        <Helmet>
          <title>{ title }</title>
          <meta name="description" content={description} />

          <meta itemProp="name" content={title} />
          <meta itemProp="description" content={description} />
          <meta itemProp="image" content={image_url} />

          <meta property="og:url" content={external_url} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={image_url} />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={title} />
          <meta name="twitter:description" content={description} />
          <meta name="twitter:image" content={image_url} />

          <link rel="canonical" href={external_url} />
        </Helmet>
    )
};

SocialMetaTags.propTypes = {
    title: propTypes.string,
    description: propTypes.string,
    image_url: propTypes.string,
    external_url: propTypes.string
}

export default SocialMetaTags;
